import { Link } from 'react-router-dom'

import appSettings from '@/config/appSettings'

const NotFound = () => (
  <div className='bg-neutral-dimmed flex min-h-screen flex-col items-center justify-center px-4'>
    <img
      src={appSettings.logo}
      alt={`${appSettings.name} logo`}
      className='mb-10 h-16 w-auto rounded-lg opacity-80'
    />

    <div className='flex flex-col items-center gap-6 text-center sm:flex-row sm:items-center sm:text-left'>
      <img
        src='/404.png'
        alt='Page not found'
        className='h-48 w-auto sm:h-56'
      />

      <div className='flex flex-col gap-3'>
        <h1 className='text-text-primary text-3xl font-bold'>
          404 — Not found
        </h1>
        <p className='text-text-tertiary text-lg'>
          Sorry, we couldn't find this page.
        </p>
        <Link
          to='/'
          className='mt-2 inline-flex w-fit items-center rounded-md bg-yellow-300 px-4 py-2 text-sm font-medium text-zinc-900 transition hover:bg-yellow-200'
        >
          Back to Homepage
        </Link>
      </div>
    </div>
  </div>
)

export default NotFound
